import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import CourseHeader from '../../components/course/CourseHeader';
import WhatYouWillLearn from '../../components/course/WhatYouWillLearn';
import CourseContent from '../../components/course/CourseContent';
import CourseDescription from '../../components/course/CourseDescription';
import { useParams } from 'react-router-dom';

const CourseDetails = () => {
    const { slug } = useParams(); // Use slug instead of id
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        axios.get(`${API_BASE_URL}/courses/${slug}`)
            .then(response => {
                setCourse(response.data.data); // API should return { data: { ...courseData } }
                setLoading(false);
            })
            .catch(error => {
                console.error("Failed to fetch course:", error);
                setLoading(false);
            });
    }, [slug]);

    if (loading) {
        return <p className="text-center mt-5">Loading course details...</p>;
    }

    if (!course) {
        return <p className="text-center mt-5">Course not found.</p>;
    }

    return (
        <>
            <SEO title={`${course.title} || PWU`} />
            <Layout>
                {/* Course Header */}
                <CourseHeader course={course} />

                {/* What You Will Learn Section */}
                <div className='container mt-5'>
                    <h2>What You Will Learn?</h2>
                    <WhatYouWillLearn details={course.details} />
                </div>

                {/* Course Topics Content Section */}
                <div className='container mt-5'>
                    <CourseContent content={course.content} />
                </div>

            </Layout>
        </>
    );
};

export default CourseDetails;
